import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { CouponStatus } from 'app/core/model/enums/status-enum';
import { CouponService } from 'app/core/services/coupon.service';
import { WebRouletteService } from 'app/public/services/web-roulette.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { FieldTypes } from 'app/shared/model/enums';
import { AdvMessageService } from 'app/shared/services/message.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-lid-details-dialog',
  templateUrl: './lid-details-dialog.component.html',
  styleUrls: ['./lid-details-dialog.component.scss']
})
export class LidDetailsDialogComponent implements OnInit {
  coupons$: Observable<any[]>;
  @ViewChild('actions') actions: TemplateRef<any>;
  couponsColumns
  @Input()
  lidId
  @Input()
  lidDetails
  @Output()
  onCouponImplemented: EventEmitter<any> = new EventEmitter<any>()
  statusType = CouponStatus
  constructor(private messageService: AdvMessageService, private localizationService: LocalizationService, private couponService: CouponService,private webRouletteService:WebRouletteService) {
   }

  ngOnInit(): void {
    this.initTable()
    this.loadCoupons()
  }
  initTable(){
    this.couponsColumns = [
      {
        field: 'Created',
        headerTranslate: 'CUSTOMERS.FIRST_WINS_CREATED_DATE',
        type: FieldTypes.fullDate
      },
      {
        field: 'CouponName',
        headerTranslate: 'CUSTOMERS.COUPON_NAME',
      },
      {
        field: 'Status',
        enumType: CouponStatus,
        enumName: 'CouponStatus',
        type: FieldTypes.enumComboBoxWithAction,
        outletTemplate: this.actions
      }
    ]
  }
  loadCoupons() {
    this.coupons$ = this.webRouletteService.getCouponsByLid(this.lidId)
      .pipe(map(res => res.Coupons));
  }
  ngAfterViewInit() {
    this.initTable();
  }
  confirmUseWin(couponNumber: number, couponName: string) {
    const customerId = this.lidId
    this.messageService.showConfirmation(this.localizationService.Translate('CUSTOMERS.USE_COUPON_TITLE'),
      this.localizationService.Translate('CUSTOMERS.USE_COUPON_MASSAGE', { couponName, customerId }), () => {
        this.couponService.implementCoupon(couponNumber).subscribe((res: any) => {
          this.messageService.successMessage('CUSTOMERS.USE_COUPON_SUCCESS', true);
          this.onCouponImplemented.emit();
        });
      });
  }
}
